module.exports = __webpack_public_path__ + "static/get-in-touch-img-38b7963e227b4b8eace65fdbd97a9b69.png";